// src/app/mocks/mock-table-data.ts
import { NotificationItem } from '../models/notification.model';

export interface ApiResponse {
  success: boolean;
  title?: string;
  body?: string;
  type?: string;
  created?: string;
  data: string | Record<string, unknown>[];
  message?: string;
}

export class MockTableData {
  
  static readonly mockTables: NotificationItem[] = [
    {
      notificationID: 1,
      title: 'Uživatelské reporty Q1 2025',
      body: 'Kompletní přehled uživatelských aktivit za první čtvrtletí. Obsahuje detailní statistiky návštěvnosti, konverzí a engagement metrik.',
      type: 2,
      created: '2025-03-15T10:30:00Z',
      senderUserID: 101,
      apnsPriority: 1,
      readAt: '2025-03-20T15:00:00Z',
      isRead: true
    },
    {
      notificationID: 2,
      title: 'Prodejní analýza - Březen',
      body: 'Měsíční analýza prodejních výsledků včetně breakdown podle produktových kategorií a regionů.',
      type: 2,
      created: '2025-03-10T14:20:00Z',
      senderUserID: 102,
      apnsPriority: 1,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 3,
      title: 'Inventura skladu',
      body: 'Výsledky inventury skladových zásob k 31.3.2025. Obsahuje přehledy podle kategorií a lokací.',
      type: 2,
      created: '2025-03-08T09:15:00Z',
      senderUserID: 103,
      apnsPriority: 1,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 4,
      title: 'Customer Support Metrics',
      body: 'Měsíční přehled zákaznických požadavků, response time a satisfaction ratings.',
      type: 2,
      created: '2025-03-05T16:45:00Z',
      senderUserID: 104,
      apnsPriority: 1,
      readAt: null,
      isRead: false
    },
    {
      notificationID: 5,
      title: 'Marketing Campaign Results',
      body: 'Výsledky marketingových kampaní za březen včetně ROI analýzy a doporučení.',
      type: 2,
      created: '2025-03-02T11:00:00Z',
      senderUserID: 105,
      apnsPriority: 1,
      readAt: null,
      isRead: false
    }
  ];

  private static readonly mockDetailData: Record<string, ApiResponse> = {
    '1': {
      success: true,
      title: 'Uživatelské reporty Q1 2025',
      body: 'Kompletní přehled uživatelských aktivit za první čtvrtletí',
      type: 'analytics',
      created: '2025-03-15T10:30:00Z',
      data: [
        { id: 1, userName: 'Jan Novák', visits: 45, conversions: 12, revenue: 15600, lastLogin: '2025-03-14T16:30:00Z', isActive: true },
        { id: 2, userName: 'Marie Svobodová', visits: 32, conversions: 8, revenue: 8900, lastLogin: '2025-03-13T14:20:00Z', isActive: true },
        { id: 3, userName: 'Petr Dvořák', visits: 28, conversions: 5, revenue: 4200, lastLogin: '2025-03-12T09:15:00Z', isActive: false },
        { id: 4, userName: 'Anna Nová', visits: 67, conversions: 18, revenue: 23400, lastLogin: '2025-03-15T11:45:00Z', isActive: true },
        { id: 5, userName: 'Tomáš Černý', visits: 19, conversions: 3, revenue: 1800, lastLogin: '2025-03-10T13:22:00Z', isActive: true }
      ]
    },
    '2': {
      success: true,
      title: 'Prodejní analýza - Březen',
      body: 'Měsíční analýza prodejních výsledků podle kategorií',
      type: 'sales',
      created: '2025-03-10T14:20:00Z',
      data: [
        { categoryId: 'ELE', categoryName: 'Elektronika', totalSales: 125000, units: 245, avgPrice: 510.20, growth: 12.5, profitable: true },
        { categoryId: 'FAM', categoryName: 'Domácnost', totalSales: 89000, units: 178, avgPrice: 500.00, growth: -2.1, profitable: true },
        { categoryId: 'SPO', categoryName: 'Sport', totalSales: 67000, units: 134, avgPrice: 500.00, growth: 8.7, profitable: true },
        { categoryId: 'BOO', categoryName: 'Knihy', totalSales: 23000, units: 460, avgPrice: 50.00, growth: -5.3, profitable: false },
        { categoryId: 'CLO', categoryName: 'Oblečení', totalSales: 156000, units: 312, avgPrice: 500.00, growth: 15.2, profitable: true }
      ]
    },
    '3': {
      success: true,
      title: 'Inventura skladu',
      body: 'Výsledky inventury skladových zásob k 31.3.2025',
      type: 'inventory',
      created: '2025-03-08T09:15:00Z',
      data: [
        { productCode: 'A001', productName: 'Notebook Dell XPS', stock: 15, reserved: 3, available: 12, value: 450000, location: 'A1-B2', lastUpdated: '2025-03-07T16:30:00Z' },
        { productCode: 'A002', productName: 'iPhone 15 Pro', stock: 8, reserved: 1, available: 7, value: 240000, location: 'A1-C3', lastUpdated: '2025-03-07T14:20:00Z' },
        { productCode: 'B001', productName: 'Kávovar DeLonghi', stock: 25, reserved: 5, available: 20, value: 125000, location: 'B2-A1', lastUpdated: '2025-03-07T10:15:00Z' },
        { productCode: 'C001', productName: 'Běžecké boty Nike', stock: 45, reserved: 8, available: 37, value: 180000, location: 'C1-D2', lastUpdated: '2025-03-06T15:45:00Z' },
        { productCode: 'D001', productName: 'Herní křeslo', stock: 12, reserved: 2, available: 10, value: 60000, location: 'D1-A3', lastUpdated: '2025-03-05T11:30:00Z' }
      ]
    },
    '4': {
      success: true,
      title: 'Customer Support Metrics',
      body: 'Měsíční přehled zákaznických požadavků a satisfaction ratings',
      type: 'support',
      created: '2025-03-05T16:45:00Z',
      data: [
        { ticketId: 'T001', customerName: 'Tech Corp s.r.o.', issue: 'Technical Problem', priority: 'High', responseTime: 2.5, resolutionTime: 24.5, satisfaction: 4.2, resolved: true },
        { ticketId: 'T002', customerName: 'Home Solutions', issue: 'Billing Question', priority: 'Medium', responseTime: 4.2, resolutionTime: 8.3, satisfaction: 4.8, resolved: true },
        { ticketId: 'T003', customerName: 'ABC Trading', issue: 'Product Return', priority: 'Low', responseTime: 6.1, resolutionTime: 48.2, satisfaction: 3.9, resolved: true },
        { ticketId: 'T004', customerName: 'XYZ Enterprise', issue: 'Account Access', priority: 'High', responseTime: 1.8, resolutionTime: 12.4, satisfaction: 4.6, resolved: true },
        { ticketId: 'T005', customerName: 'Local Business', issue: 'Feature Request', priority: 'Medium', responseTime: 5.5, resolutionTime: 72.1, satisfaction: 4.1, resolved: false }
      ]
    },
    '5': {
      success: true,
      title: 'Marketing Campaign Results',
      body: 'Výsledky marketingových kampaní za březen včetně ROI analýzy',
      type: 'marketing',
      created: '2025-03-02T11:00:00Z',
      data: [
        { campaignId: 'CAM001', campaignName: 'Spring Sale 2025', channel: 'Email', impressions: 125000, clicks: 3250, conversions: 245, spend: 15000, revenue: 89000, roi: 593 },
        { campaignId: 'CAM002', campaignName: 'Social Media Push', channel: 'Facebook', impressions: 85000, clicks: 2100, conversions: 156, spend: 8500, revenue: 52000, roi: 612 },
        { campaignId: 'CAM003', campaignName: 'Google Ads Q1', channel: 'Google', impressions: 200000, clicks: 5800, conversions: 389, spend: 25000, revenue: 145000, roi: 580 },
        { campaignId: 'CAM004', campaignName: 'Influencer Collab', channel: 'Instagram', impressions: 45000, clicks: 1250, conversions: 78, spend: 12000, revenue: 28000, roi: 233 },
        { campaignId: 'CAM005', campaignName: 'Newsletter Special', channel: 'Email', impressions: 65000, clicks: 1890, conversions: 134, spend: 3500, revenue: 45000, roi: 1286 }
      ]
    }
  };

  static getTableList(): NotificationItem[] {
    return [...this.mockTables];
  }

  static getTableDetail(tableId: string): ApiResponse {
    return this.mockDetailData[tableId] || {
      success: false,
      message: 'Table not found',
      data: []
    };
  }

  static addMockTable(table: NotificationItem): void {
    this.mockTables.push(table);
  }

  static resetData(): void {
  }
}